import axios from 'axios';

export interface PlacePrediction {
  place_id: string;
  description: string;
  structured_formatting: {
    main_text: string;
    secondary_text: string;
  };
  terms: { offset: number; value: string }[];
  types: string[];
}

export interface PlaceDetails {
  place_id: string;
  formatted_address: string;
  address_components: {
    long_name: string;
    short_name: string;
    types: string[];
  }[];
}

type PlacesAPIResponse = {
  predictions: PlacePrediction[];
};

export const getGooglePlacesResults = async (
  input: string,
  locale: string,
  sessionToken?: string
) => {
  const searchParams = new URLSearchParams({
    input,
    locale
  });
  if (sessionToken) {
    searchParams.append('sessionToken', sessionToken);
  }

  const res = await axios.get<PlacesAPIResponse>(
    `/api/google/places/autocomplete?${searchParams.toString()}`
  );
  return res.data.predictions;
};

export const getGooglePlaceDetail = async (
  placeId: string,
  locale: string,
  sessionToken?: string
) => {
  const searchParams = new URLSearchParams({
    place_id: placeId,
    locale
  });
  if (sessionToken) {
    searchParams.append('sessionToken', sessionToken);
  }

  const res = await axios.get<PlaceDetails>(
    `/api/google/places/details?${searchParams.toString()}`
  );
  return res.data;
};
